import { RhNumberField } from '../../../../../../dum';
import React from 'react';
import {
    IExpense,
    NON_TAX_RETAINED,
    REQUIRE_TAX,
} from '../expense-form';
import { useCalculateExpenseTotal } from '../use-calculate-expense-total';
import { useSetFirstExpenseResourceItem } from '../use-set-first-expense-resource-item';
import { useCalculateExpenseResourcesTotal } from '../use-calculate-expense-resources-total';
import { useFieldRevert } from '../use-field-revert';
import { RevertHint } from '../revert-hint';
import { useWatch } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function NonTaxRetainedInput() {
    const { calculateExpenseTotal } = useCalculateExpenseTotal();
    const { setFirstExpenseResourceItem } = useSetFirstExpenseResourceItem();
    const { calculateExpenseResourcesTotal } =
        useCalculateExpenseResourcesTotal();
    const { original, hasChanged, revert } = useFieldRevert(NON_TAX_RETAINED);
    const requireTax = useWatch({
        name: REQUIRE_TAX,
    }) as IExpense['require_tax'];
    const nonTaxRetained = useWatch({
        name: NON_TAX_RETAINED,
    }) as IExpense['non_tax_retained'];
    const disableNonTaxRetained =
        !requireTax && Number(nonTaxRetained) === 0;

    return (
        <RhNumberField
            name={NON_TAX_RETAINED}
            label={shortLabel(FIELD_LABELS.non_tax_retained)}
            disabled={disableNonTaxRetained}
            onChange={() => {
                calculateExpenseTotal();
                setFirstExpenseResourceItem();
                calculateExpenseResourcesTotal();
            }}
            helperText={
                <RevertHint
                    hasChanged={!!requireTax && hasChanged}
                    original={original}
                    onRevert={() => {
                        revert();
                        calculateExpenseTotal();
                    }}
                />
            }
        />
    );
}
